// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"91":"c49bd777","198":"10638c8e","329":"479d9715","498":"ca869461","703":"c57aaee3","787":"9e9f4ffd"}[chunkId] + ".chunk.js";
};